import { FiRotateCw } from "react-icons/fi";

import { Filter } from "../../Models/Filter";

import "./ActiveFilters.css"

interface ActiveFiltersProps {
    activeFilters: Filter[];
    onToggle: (filter: Filter) => void;
    resetFilters: () => void;
}

const ActiveFilters: React.FC<ActiveFiltersProps> = ({
    activeFilters,
    onToggle,
    resetFilters
}) => {

    // Don't render anything if there are no active filters
    if (activeFilters.length === 0) return null;

    return (
        <div id="Active-Filters-Container">
            {/* Display each active filter with a toggle option */}
            {activeFilters.map((f) => (
                <div key={f.value} className="Active-Filters-Item">
                    <span className="Active-Filters-Item-Text">
                        {!f.value || f.value.trim() === "" ? "non connu" : f.value}
                    </span>
                    <button className="Active-Filters-Item-Icone" onClick={() => onToggle(f)}>
                        X
                    </button>
                </div>
            ))}

            {/* Button to reset all filters */}
            <button className="Reset-Button" onClick={resetFilters}>
                <span className="Reset-Button-Text">Réinitialiser</span>
                <FiRotateCw className="Reset-Button-Icone" />
            </button>
        </div>
    )
}

export default ActiveFilters;